
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 27 18","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M.53.154l13.033 9.242L26.598.154H.53zm13.033 10.542L10.401 8.42l-9.92 9.26h25.283l-9.261-9.1-2.94 2.117zm3.713-2.673l9.48 9.313V1.196l-9.48 6.827zM0 .929L9.625 7.86 0 16.843V.93z"}})])
          )
        }
      }
    